import { OptimizelyDecision, useDecision } from '@optimizely/react-sdk';

export const useFeatureFlag = (
    flagKey: string,
): [OptimizelyDecision | Partial<OptimizelyDecision>, boolean, boolean] => {
    const [decision, clientReady, didTimeout] = useDecision(flagKey);

    if (didTimeout) {
        return [decision || { enabled: false }, true, didTimeout];
    }

    return [decision, clientReady, didTimeout];
};
